export const backendserverurl='https://0005-bakdata.umojaimcouriers.com'

//https://1-be-pifs01-mta-app1.pitech.co.ug
//127.0.0.1:8000
//159.223.133.216
//http://138.197.8.179:10225/
//159.223.133.216:10225

//demo
//https://0005-bakdata.umojaimcouriers.com/

//sl 
//https://001-0005-bakdataaa.umojaimcouriers.com/

//demo http://159.223.133.216:10225

